import { Injectable } from "@angular/core";

export const keysLS = {
  requestsFilterSetting: "requestsFilterSetting",
  isMinimisedNavBar: "isMinimisedNavBar",
  reportsPhotoFilterSettings: "reportsPhotoFilterSettings",
} as const;

export type KeysLS = (typeof keysLS)[keyof typeof keysLS];

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  public set<T>(key: KeysLS, value: T): void {
    try {
      const json = JSON.stringify(value);
      localStorage.setItem(key, json);
    } catch (e) {
      console.error("LocalStorage set error:", e);
    }
  }

  public get<T>(key: KeysLS): T | null {
    try {
      const json = localStorage.getItem(key);
      return json ? (JSON.parse(json) as T) : null;
    } catch (e) {
      console.error("LocalStorage get error:", e);
      return null;
    }
  }

  public has(key: KeysLS): boolean {
    return localStorage.getItem(key) !== null;
  }

  public remove(key: KeysLS): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
